import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useShangpinjiaochengUpdateQuery, useShangpinjiaochengUpdateSaveMutation,} from '../../store/dianshangtaizhangApi';
import MyEditor from '../../cpn/MyEditor';
function GoodsCourseEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false); 
    const [info,setInfo] = useState({
        spjc_remark:'',
        spjc_content:'',
    }); 
    const {data,isSuccess} = useShangpinjiaochengUpdateQuery({spjc_id:props.spjc_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    spjc_sp_name:data.Result.spjc_sp_name,                   
                    spjc_name:data.Result.spjc_name,
                    spjc_content:data.Result.spjc_content,
                    spjc_remark:data.Result.spjc_remark,
                })
                setInfo(prevState=>({...prevState,
                    spjc_sp_id:data.Result.spjc_sp_id,
                    spjc_sp_name:data.Result.spjc_sp_name,                   
                    spjc_name:data.Result.spjc_name,
                    spjc_content:data.Result.spjc_content,      
                    spjc_remark:data.Result.spjc_remark,      
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useShangpinjiaochengUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改商品规格'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "spjc_content" : info.spjc_content,
                        "spjc_id" : props.spjc_id,
                        "spjc_name" : info.spjc_name,
                        "spjc_remark" : info.spjc_remark,                       
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                       
                    <Form.Item name="spjc_name" wrapperCol={{span:10}} label='表单名称' required>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spjc_name:e.target.value}))
                        }}/>
                    </Form.Item> 
                    <Form.Item name="spjc_remark" label='表单介绍' wrapperCol={{span:15}} >
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,spjc_remark:e}))}} value={info.spjc_remark}/>
                    </Form.Item>
                    <Form.Item name="spjc_content" label='教程' wrapperCol={{span:15}} >
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,spjc_content:e}))}} value={info.spjc_content}/>
                    </Form.Item>                  
                </Form>
            </Modal>
        </>
    )
}

export default GoodsCourseEdit